export interface Vertex {
  vertexPosition: string
  vertexNormal: string
}

export interface WorldPosition {
  x: number
  y: number
  z: number
}

export class KVInspectionArea {
  id: string
  label: string
  notes: string
  status: string
  severity: string
  visible: boolean
  fillVisible: boolean
  perimeterVisible: boolean
  vertices: Vertex[]
  area?: number
  perimeter?: number
  centroid?: WorldPosition
  normal?: WorldPosition
  cameraFacingNormal?: WorldPosition // Normal facing toward camera at creation time
  workOrderCount?: number
  userName: string
  userEmail: string
  createdAt: string

  constructor(id: string) {
    this.id = id
    this.label = ''
    this.notes = ''
    this.status = 'Not Started'
    this.severity = '3'
    this.visible = true
    this.fillVisible = true
    this.perimeterVisible = true
    this.vertices = []
    this.area = undefined
    this.perimeter = undefined
    this.centroid = undefined
    this.normal = undefined
    this.cameraFacingNormal = undefined
    this.workOrderCount = undefined
    this.userName = ''
    this.userEmail = ''
    this.createdAt = new Date().toISOString()
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  static fromJSON(json: any): KVInspectionArea {
    const inspectionArea = new KVInspectionArea(json.inspectionAreaId)
    if (json.inspectionAreaLabel)
      inspectionArea.label = json.inspectionAreaLabel
    if (json.inspectionAreaNotes)
      inspectionArea.notes = json.inspectionAreaNotes
    if (json.inspectionAreaStatus)
      inspectionArea.status = json.inspectionAreaStatus
    if (json.inspectionAreaSeverity)
      inspectionArea.severity = json.inspectionAreaSeverity
    if (json.inspectionAreaVisible !== undefined)
      inspectionArea.visible = json.inspectionAreaVisible
    if (json.inspectionAreaFillVisible !== undefined)
      inspectionArea.fillVisible = json.inspectionAreaFillVisible
    if (json.inspectionAreaPerimeterVisible !== undefined)
      inspectionArea.perimeterVisible = json.inspectionAreaPerimeterVisible
    if (json.inspectionAreaVertices)
      inspectionArea.vertices = json.inspectionAreaVertices

    // Add area and perimeter parsing:
    if (json.inspectionAreaArea !== undefined)
      inspectionArea.area = json.inspectionAreaArea
    if (json.inspectionAreaPerimeter !== undefined)
      inspectionArea.perimeter = json.inspectionAreaPerimeter

    // Add centroid and normal parsing:
    if (json.inspectionAreaCentroid)
      inspectionArea.centroid = json.inspectionAreaCentroid
    if (json.inspectionAreaNormal)
      inspectionArea.normal = json.inspectionAreaNormal
    if (json.inspectionAreaCameraFacingNormal)
      inspectionArea.cameraFacingNormal = json.inspectionAreaCameraFacingNormal

    if (json.inspectionAreaWorkOrderCount !== undefined)
      inspectionArea.workOrderCount = json.inspectionAreaWorkOrderCount

    if (json.userName) inspectionArea.userName = json.userName
    if (json.userEmail) inspectionArea.userEmail = json.userEmail
    if (json.createdAt) inspectionArea.createdAt = json.createdAt

    return inspectionArea
  }

  static toJSON(inspectionArea: KVInspectionArea): any {
    return {
      inspectionAreaId: inspectionArea.id,
      inspectionAreaLabel: inspectionArea.label,
      inspectionAreaNotes: inspectionArea.notes,
      inspectionAreaStatus: inspectionArea.status,
      inspectionAreaSeverity: inspectionArea.severity,
      inspectionAreaVisible: inspectionArea.visible,
      inspectionAreaFillVisible: inspectionArea.fillVisible,
      inspectionAreaPerimeterVisible: inspectionArea.perimeterVisible,
      inspectionAreaVertices: inspectionArea.vertices,

      // Add area and perimeter to output:
      inspectionAreaArea: inspectionArea.area,
      inspectionAreaPerimeter: inspectionArea.perimeter,

      // Add centroid and normal to output:
      inspectionAreaCentroid: inspectionArea.centroid,
      inspectionAreaNormal: inspectionArea.normal,
      inspectionAreaCameraFacingNormal: inspectionArea.cameraFacingNormal,

      inspectionAreaWorkOrderCount: inspectionArea.workOrderCount,

      userName: inspectionArea.userName,
      userEmail: inspectionArea.userEmail,
      createdAt: inspectionArea.createdAt,
    }
  }
}
